export function getRuntimeOrigin(): string {
  return typeof window !== 'undefined' ? window.location.origin : '';
}

export function getRuntimeHost(fallback = 'Snake Game'): string {
  return typeof window !== 'undefined' ? window.location.host : fallback;
}
